import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "lib/utils";
import { forwardRef, type InputHTMLAttributes, type Ref } from "react";

const inputVariants = cva("input input-bordered w-full", {
  variants: {
    size: {
      sm: "input-sm",
      md: "input-md",
      lg: "input-lg",
    },
    tone: {
      default: "",
      invalid: "input-error",
    },
  },
  defaultVariants: {
    size: "sm",
    tone: "default",
  },
});

type InputVariantProps = VariantProps<typeof inputVariants>;

export type InputProps = {
  size?: InputVariantProps["size"];
  tone?: InputVariantProps["tone"];
} & Omit<InputHTMLAttributes<HTMLInputElement>, "className" | "size">;

/**
 * 純粋な Input リーフ。RHF 非依存、className は意図的に受け取らない。
 * デザインはすべてこのファイルに閉じ込める。
 * @param {InputProps} props Input の props
 * @param {Ref<HTMLInputElement>} ref 転送される ref
 * @return {JSX.Element} Input 要素
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ size, tone, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(inputVariants({ size, tone }))}
        {...rest}
      />
    );
  },
);
Input.displayName = "Input";
